export const JOB_BOARD_TUTORIAL_STEPS = [
  {
    id: 'job-listings',
    title: 'Job Listings',
    description:
      'Browse through our curated list of internship opportunities. Use the search bar and filters to find the perfect role for you!',
    placement: 'top',
    image: '/maincar.png',
  },
  {
    id: 'add-application',
    title: 'Save to App Tracker',
    description:
      'Click "Add Application" to automatically add this role to your application tracker. Note: You\'ll need to complete certain lessons to unlock this feature!',
    placement: 'left',
    image: '/thinkingcar.png',
  },
  {
    id: 'apply-now',
    title: 'Apply Now',
    description: 'Click here to apply for your first job!',
    placement: 'left',
    image: '/maincar.png',
  },
];
